import React from 'react';
import PropTypes from 'prop-types';

function HowToUse(props) {
  const { text } = props;
  return (
    <div dangerouslySetInnerHTML={{ __html: text }} />
  );
}

HowToUse.propTypes = {
  text: PropTypes.string.isRequired,
};

export default HowToUse;
